<template>
  <div>
    <Navbar :on-go-back="goBack"></Navbar>

    <form class="l-content" @submit.prevent="submit">
      <div class="l-container">
        <div class="c-container">
          <div class="c-title u-ptxl">
            <span class="u-anim-slideup">メールアドレスを入力してください</span>
          </div>
        </div>
      </div>

      <div class="l-container">
        <div class="c-container">
          <TextField label="メールアドレス" type="email" autofocus requied placeholder="例）sample@example.com" v-model="state.email"></TextField>
        </div>
      </div>

      <div class="l-container">
        <div class="c-container">
          <div class="agreement-checkbox u-mtl">
            <div class="u-prxs">
              <Checkbox v-model="state.isAgreedTerms" @click="isAgreedTerms = !isAgreedTerms"></Checkbox>
            </div>
            <div>
              ギグベースの<a class="u-text-underline" href="https://gigbase.jp/terms" target="_blank">利用規約</a>と
              <a class="u-text-underline" href="https://gigbase.jp/personal" target="_blank">プライバシーポリシー</a>
              ・
              <a class="u-text-underline" href="https://gigbase.jp/privacy/talent" target="_blank">個人情報の取扱い</a>
              、並びに
              <a class="u-text-underline" :href="antiSocialAgreeUrl" target="_blank">反社・犯罪歴</a>に同意する。
            </div>
          </div>
        </div>
      </div>

      <FloatingButton type="submit" :disabled="!isValid"></FloatingButton>
    </form>
  </div>
</template>

<script lang="babel">
import Navbar from "@/components/navbar/Navbar";
import FloatingButton from "@/components/button/FloatingButton";
import TextField from "@/components/TextField";
import EmailAuthorization from '@/api/v2/email_authorizations';
import Checkbox from "@/components/Checkbox";
import nativeMethodDispatcher from "@/utils/nativeMethodDispatcher";
import {computed, defineComponent, onMounted, reactive} from "vue";
import {usePlatformType} from "@/composables/usePlatformType";
import {useRouter} from "vue-router/composables";
import {inject} from "vue";
import {SIGNUP_STORE} from "@/constants/InjectionKeys";
import {useAlert} from "@/composables/useAlert";

export default defineComponent({
  name: "EmailAuthorization",
  components: {
    Checkbox,
    TextField,
    FloatingButton,
    Navbar
  },
  setup(_, { emit }) {
    emit('page-navbar', false)
    const antiSocialAgreeUrl = process.env.VUE_APP_API_BASE_URL + '/criminal';

    const state = reactive({
      email: null,
      isAgreedTerms: false
    })
    const isValid = computed(() => state.email && state.isAgreedTerms)

    const router = useRouter()
    const { showErrorAlert } = useAlert()
    const { setWorker } = inject(SIGNUP_STORE)

    const submit = () => {
      if (!state.isAgreedTerms) {
        return;
      }
      emit('loading', true);

      EmailAuthorization.send(state.email, state.referrer)
        .then(() => {
          setWorker({ email: state.email });
          router.replace({ name: 'emailAuthorizationSent' });
        })
        .catch(showErrorAlert)
        .finally(() => {
          emit('loading', false)
        });
    }
    const goBack = () => {
      const { isIos, isAndroid } = usePlatformType()

      if (isIos() || isAndroid()) {
        nativeMethodDispatcher.dispatch('close');
      } else {
        router.go(-1)
      }
    }

    return { state, isValid, antiSocialAgreeUrl, goBack, submit }
  }
})
</script>

<style scoped lang="scss">
.c-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.03em;
  text-align: left;
}

.agreement-checkbox {
  display: flex;
  justify-content: center;
}
</style>
